export const options = {
  domainMax: 100,
  dots: true,
  height: 360,
  tooltip: true,
  dataXFormat: 'month'
};

export const tooltipColors = {
  red: '#ffe0e5',
  yellow: '#fffbe1',
  lgreen: '#d9f5e8',
  green: '#9ee5c5'
};
